module.exports = __webpack_public_path__ + "img/crown-full-purple.48069645.svg";